export const AUDIT_OVERVIEW_ROUTE_NAMES = [
    'AuditOverview',
    'AdminAuditOverview',
];

export const AUDIT_OVERVIEW_PANEL_QUERY_GROUPS = {
    auditSummary: ['panel'],
    actionItem: ['actionItemHash', 'gapHash'],
    gap: ['gapHash', 'actionItemHash'],
};

export const AUDIT_SUMMARY_PANEL_QUERY_TO_TYPE = {
    summary: 'viewSummary',
    template: 'viewTemplate',
};

export const AUDIT_SUMMARY_PANEL_TYPE_TO_QUERY = {
    viewSummary: 'summary',
    editSummary: 'summary',
    viewTemplate: 'template',
    editTemplate: 'template',
};

export function isAuditOverviewRoute(route) {
    return AUDIT_OVERVIEW_ROUTE_NAMES.includes(route?.name);
}

export function getAuditOverviewAuditHash(route) {
    return route?.params?.auditHash || route?.params?.hash || null;
}

export function buildAuditOverviewPanelQuery(baseQuery, activeGroup, updates = {}) {
    const query = { ...(baseQuery || {}) };

    Object.entries(AUDIT_OVERVIEW_PANEL_QUERY_GROUPS).forEach(
        ([group, keys]) => {
            if (group === activeGroup) return;
            keys.forEach((key) => {
                delete query[key];
            });
        }
    );

    delete query.actionItemPanel;

    Object.entries(updates).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
            delete query[key];
        } else {
            query[key] = value;
        }
    });

    return query;
}

export function clearAuditOverviewPanelQuery(baseQuery, group = null) {
    const query = { ...(baseQuery || {}) };
    const groups = group
        ? { [group]: AUDIT_OVERVIEW_PANEL_QUERY_GROUPS[group] }
        : AUDIT_OVERVIEW_PANEL_QUERY_GROUPS;

    Object.values(groups)
        .flat()
        .forEach((key) => {
            delete query[key];
        });

    delete query.actionItemPanel;

    return query;
}

export function pushAuditOverviewRoute(router, route, { query, hash } = {}) {
    if (route.name === 'AdminAuditOverview') {
        router.push({
            name: 'AdminAuditOverview',
            params: {
                companyHash: route.params.companyHash,
                auditHash: route.params.auditHash,
            },
            query: query ?? route.query,
            hash: hash ?? route.hash ?? '',
        });
        return;
    }

    router.push({
        name: 'AuditOverview',
        params: { hash: route.params.hash },
        query: query ?? route.query,
        hash: hash ?? route.hash ?? '',
    });
}

export function getAuditSummaryPanelTypeFromQuery(panel) {
    if (panel === 'edit') {
        return 'viewSummary';
    }
    return AUDIT_SUMMARY_PANEL_QUERY_TO_TYPE[panel] || null;
}

export function getAuditSummaryPanelQueryFromType(panelType) {
    return AUDIT_SUMMARY_PANEL_TYPE_TO_QUERY[panelType] || null;
}

export function isAuditSummaryPanelQuery(panel) {
    return ['summary', 'template'].includes(panel);
}

export function normalizeRouteQueryValue(value) {
    if (Array.isArray(value)) {
        return value[0]?.trim() || null;
    }
    return typeof value === 'string' ? value.trim() || null : null;
}
